import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, forwardRef } from '@angular/core';
import { DynamicComponentComponent } from 'app/modules/admin/dynamic-component/dynamic-component.component';
import { DrakeGridComponent } from 'app/drake-components/drake-grid/drake-grid.component';
import { MatIconModule } from '@angular/material/icon';
import { ChartsModule, SelectEvent } from "@progress/kendo-angular-charts";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { SharedService } from 'app/services/shared.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageService } from 'app/services/page.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { TranslocoPipe } from '@ngneat/transloco';
import { DrakeCustomComponentComponent } from '../drake-custom-component/drake-custom-component.component';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'x',
  standalone: true,
  templateUrl: './drake-scope-listview.component.html',
  styleUrls: ['./drake-scope-listview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
     DrakeCustomComponentComponent,
    DrakeGridComponent,
    CommonModule,
    HttpClientModule,
    ChartsModule,
    MatIconModule,
    InputsModule,
    TabStripModule,
    LayoutModule,
  TranslocoPipe]
})
export class DrakeScopeListviewComponent implements OnInit,OnDestroy {
  public pageData: any;
  public baseData: any = {};
  public scope: string = '';
  public viewCode: string = '';
  public componentCode: string = '';
  public filter: string = '{}';
  public sort: string = '{}';
  public commandName: string = 'READ';
  private subscription:Subscription;

  constructor(
    private sharedService: SharedService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private pageService: PageService, 
    private activatedRoute: ActivatedRoute,
    private drakeShared: DrakeSharedService) {
      this.setGridConfig();
      this.subscription = this.router.events.subscribe(event =>{
        if (event instanceof NavigationEnd){
           console.log(event.url)
           this.setGridConfig();
        }
     })

  }
  ngOnInit(): void {
    /*this.router.events.subscribe((val) => {
      console.log(val)
      if (val instanceof NavigationEnd) {
        this.setGridConfig();
      }
    })*/

  }
  setGridConfig(){
    this.drakeShared.currentBaseData = this.baseData;
        this.route.params.subscribe(params => {

          this.pageService.getPageByUrl(location.pathname.substring(1)).subscribe((result: any) => {
            this.pageData = result;
            this.drakeShared.currentPageData = result;
            const urlParams = new URLSearchParams(window.location.search);
            const filter = urlParams.get('filter') || '{}';
            this.filter = this.decodeJSONString(filter);
            const sort = urlParams.get('sort') || '{}';
            this.sort = this.decodeJSONString(sort);
            this.commandName = 'READ';
            this.scope = params['scope'].toUpperCase();
            this.viewCode = params['viewCode'] ? params['viewCode'].toUpperCase() : this.scope + '.DEFAULT';
            this.componentCode = params['componentCode'] ? params['componentCode'].toUpperCase() : this.scope + '.GRID';
          });
        })
  }

  decodeJSONString(str: string): string {
    try {
      const decodedStr = str.replace(/\\\"/g, '"');
      const parsedJSON = JSON.parse(decodedStr);
      return JSON.stringify(parsedJSON);
    } catch (e) {
      console.error('Invalid JSON string:', str);
      return '{}'; // Fallback to an empty object if parsing fails
    }
  }
  public onTabSelect(e: SelectEvent): void {
    console.log(e);
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}